(function () {
  'use strict';

  document.querySelectorAll('[data-efm-root]').forEach(function (root) {

    var node =
      root.querySelector('[data-efm-product-json]');

    if (!node) return;


    var product;

    try {

      product =
        JSON.parse(node.textContent);

    } catch (error) {

      return;

    }


    var buttons = Array.from(
      root.querySelectorAll('[data-efm-scent]')
    );


    var resultText =
      root.querySelector(
        '[data-efm-result-scent]'
      );


    var resultImage =
      root.querySelector(
        '[data-efm-result-image]'
      );


    var priceText =
      root.querySelector(
        '[data-efm-result-price]'
      );


    var status =
      root.querySelector(
        '[data-efm-status]'
      );


    var add =
      root.querySelector(
        '[data-efm-add]'
      );


    var finalSelect =
      root.querySelector(
        '[data-efm-final-select]'
      );


    var finalImage =
      root.querySelector(
        '[data-efm-final-image]'
      );


    var finalPrice =
      root.querySelector(
        '[data-efm-final-price]'
      );


    var finalAdd =
      root.querySelector(
        '[data-efm-final-add]'
      );


    var selected = '';


    /* =========================
       HELPERS
    ========================= */

    function norm(value) {

      return String(value || '')
        .trim()
        .toLowerCase()
        .replace(
          /[\s　_\-・]/g,
          ''
        );

    }


    function money(cents) {

      return (
        '¥' +
        Math.round(
          Number(cents || 0) / 100
        ).toLocaleString('ja-JP') +
        '（税込）'
      );

    }


    function findVariant() {

      if (!selected) {
        return null;
      }


      return (
        product.variants || []
      ).find(
        function (variant) {

          return (
            variant.options || []
          ).some(
            function (option) {

              return (
                norm(option) ===
                norm(selected)
              );

            }
          );

        }
      ) || null;

    }


    function findVariantById(id) {

      if (!id) {
        return null;
      }


      return (
        product.variants || []
      ).find(
        function (variant) {

          return (
            String(variant.id) ===
            String(id)
          );

        }
      ) || null;

    }


    function findVariantByScent(
      scent
    ) {

      if (!scent) {
        return null;
      }


      return (
        product.variants || []
      ).find(
        function (variant) {

          return (
            variant.options || []
          ).some(
            function (option) {

              return (
                norm(option) ===
                norm(scent)
              );

            }
          );

        }
      ) || null;

    }


    function findButtonForVariant(
      variant
    ) {

      if (!variant) {
        return null;
      }


      return buttons.find(
        function (button) {

          return (
            variant.options || []
          ).some(
            function (option) {

              return (
                norm(option) ===
                norm(
                  button.dataset.efmScent
                )
              );

            }
          );

        }
      ) || null;

    }


    function findButtonForSelected() {

      if (!selected) {
        return null;
      }


      return buttons.find(
        function (button) {

          return (
            norm(
              button.dataset.efmScent
            ) ===
            norm(selected)
          );

        }
      ) || null;

    }


    function setButtonState(
      activeButton
    ) {

      buttons.forEach(
        function (button) {

          var active =
            button === activeButton;


          button.classList.toggle(
            'is-selected',
            active
          );


          button.setAttribute(
            'aria-pressed',
            active
              ? 'true'
              : 'false'
          );

        }
      );

    }


    /* =========================
       STOCK
    ========================= */

    function setStockState(
      button,
      soldOut
    ) {

      button.disabled =
        soldOut;


      button.classList.toggle(
        'is-sold-out',
        soldOut
      );


      button.setAttribute(
        'aria-disabled',
        soldOut
          ? 'true'
          : 'false'
      );


      var label =
        button.querySelector(
          '.efm-stock-label'
        );


      if (soldOut) {

        if (!label) {

          label =
            document.createElement(
              'span'
            );


          label.className =
            'efm-stock-label';


          label.textContent =
            'SOLD OUT';


          label.setAttribute(
            'aria-label',
            '在庫切れ'
          );


          button.appendChild(
            label
          );

        }

      } else if (label) {

        label.remove();

      }

    }


    function getOriginalOptionLabel(
      option
    ) {

      if (
        !option.dataset.efmOriginalLabel
      ) {

        option.dataset.efmOriginalLabel =
          option.textContent
            .trim()
            .replace(
              /\s*｜SOLD OUT$/,
              ''
            );

      }


      return (
        option.dataset.efmOriginalLabel
      );

    }


    function refreshFinalSelectStock() {

      if (!finalSelect) {
        return;
      }


      Array.from(
        finalSelect.options
      ).forEach(
        function (option) {

          if (!option.value) {
            return;
          }


          var variant =
            findVariantById(
              option.value
            );


          var soldOut =
            !variant ||
            !variant.available;


          option.disabled =
            soldOut;


          option.textContent =
            getOriginalOptionLabel(
              option
            ) +
            (
              soldOut
                ? '｜SOLD OUT'
                : ''
            );

        }
      );

    }


    function refreshStock() {

      /*
        香りカード
      */

      buttons.forEach(
        function (button) {

          var scent =
            button.dataset.efmScent || '';


          var variant =
            findVariantByScent(
              scent
            );


          var soldOut =
            !variant ||
            !variant.available;


          setStockState(
            button,
            soldOut
          );

        }
      );


      /*
        下の購入フォーム
      */

      refreshFinalSelectStock();


      /*
        万一選択中の商品が
        SOLD OUTなら解除
      */

      if (selected) {

        var current =
          findVariantByScent(
            selected
          );


        if (
          !current ||
          !current.available
        ) {

          selected = '';

          setButtonState(
            null
          );

        }

      }

    }


    /* =========================
       IMAGE
    ========================= */

    function getImage(
      button,
      variant
    ) {

      if (
        button &&
        button.dataset.efmImage
      ) {

        return (
          button.dataset.efmImage
        );

      }


      if (
        variant &&
        variant.image
      ) {

        return variant.image;

      }


      return '';

    }


    function getImageAlt(
      button
    ) {

      if (
        button &&
        button.dataset.efmImageAlt
      ) {

        return (
          button.dataset.efmImageAlt
        );

      }


      return (
        'ETERNAL FLOWER Multi Oil'
      );

    }


    function setImage(
      imageNode,
      src,
      alt
    ) {

      if (
        !imageNode ||
        !src
      ) {

        return;

      }


      imageNode.src =
        src;


      if (alt) {

        imageNode.alt =
          alt;

      }

    }


    function syncImages(
      button,
      variant
    ) {

      var image =
        getImage(
          button,
          variant
        );


      if (!image) {
        return;
      }


      var alt =
        getImageAlt(
          button
        );


      setImage(
        resultImage,
        image,
        alt
      );


      setImage(
        finalImage,
        image,
        alt
      );

    }


    /* =========================
       FINAL FORM
    ========================= */

    function syncFinalForm(
      variant
    ) {

      if (!variant) {

        if (finalAdd) {

          finalAdd.disabled = true;

        }


        return;

      }


      if (finalSelect) {

        finalSelect.value =
          String(
            variant.id
          );

      }


      if (finalPrice) {

        finalPrice.textContent =
          money(
            variant.price
          );

      }


      if (finalAdd) {

        finalAdd.disabled =
          !variant.available;

      }

    }


    /* =========================
       UPDATE
    ========================= */

    function update() {


      /*
        最初にSOLD OUTを更新
      */

      refreshStock();


      var variant =
        findVariant();


      var button =
        findButtonForSelected();


      var displayName =
        button &&
        button.dataset.efmName
          ? button.dataset.efmName
          : selected;


      if (resultText) {

        resultText.textContent =
          displayName ||
          '香りを選択してください';

      }


      if (add) {

        add.dataset.variantId =
          variant
            ? variant.id
            : '';


        add.disabled =
          !variant ||
          !variant.available;

      }


      /*
        未選択
      */

      if (!selected) {

        if (status) {

          status.textContent =
            '香りをお選びください。';

        }


        return;

      }


      /*
        Variantがない
      */

      if (!variant) {

        if (status) {

          status.textContent =
            '選択した香りの商品情報が見つかりませんでした。商品オプションの値をご確認ください。';

        }


        return;

      }


      /*
        STATUS
      */

      if (!variant.available) {

        if (status) {

          status.textContent =
            'この香りは、ただいまSOLD OUTです。';

        }

      } else {

        if (status) {

          status.textContent =
            '選択内容をご確認のうえ、カートへお進みください。';

        }

      }


      /*
        PRICE
      */

      if (priceText) {

        priceText.textContent =
          money(
            variant.price
          );

      }


      /*
        IMAGE
      */

      syncImages(
        button,
        variant
      );


      /*
        FINAL FORM
      */

      syncFinalForm(
        variant
      );

    }


    /* =========================
       SCENT BUTTONS
    ========================= */

    buttons.forEach(
      function (button) {

        button.addEventListener(
          'click',
          function () {


            /*
              SOLD OUTなら
              何もしない
            */

            if (button.disabled) {
              return;
            }


            selected =
              button.dataset.efmScent;


            setButtonState(
              button
            );


            update();


            /*
              結果へスクロール
            */

            var result =
              root.querySelector(
                '[data-efm-result]'
              );


            if (result) {

              setTimeout(
                function () {

                  result.scrollIntoView({
                    behavior:
                      'smooth',

                    block:
                      'start'
                  });

                },
                100
              );

            }

          }
        );

      }
    );


    /* =========================
       FINAL SELECT
    ========================= */

    if (finalSelect) {

      finalSelect.addEventListener(
        'change',
        function () {


          var variant =
            findVariantById(
              finalSelect.value
            );


          if (!variant) {
            return;
          }


          /*
            念のため
            SOLD OUTは選択不可
          */

          if (!variant.available) {

            refreshFinalSelectStock();

            return;

          }


          var button =
            findButtonForVariant(
              variant
            );


          if (button) {

            selected =
              button.dataset.efmScent;


            setButtonState(
              button
            );


            update();

          } else {


            if (finalPrice) {

              finalPrice.textContent =
                money(
                  variant.price
                );

            }


            if (finalAdd) {

              finalAdd.disabled =
                !variant.available;

            }


            if (
              variant.image &&
              finalImage
            ) {

              setImage(
                finalImage,
                variant.image,
                'ETERNAL FLOWER Multi Oil'
              );

            }

          }


          refreshStock();

        }
      );

    }


    /* =========================
       CENTER ADD TO CART
    ========================= */

    if (add) {

      add.addEventListener(
        'click',
        async function () {


          var id =
            Number(
              add.dataset.variantId
            );


          if (!id) {
            return;
          }


          var currentVariant =
            findVariantById(
              id
            );


          if (
            !currentVariant ||
            !currentVariant.available
          ) {

            return;

          }


          var originalLabel =
            add.textContent;


          add.disabled = true;


          add.textContent =
            '追加中…';


          try {


            var response =
              await fetch(
                '/cart/add.js',
                {

                  method:
                    'POST',


                  headers: {

                    'Content-Type':
                      'application/json',

                    'Accept':
                      'application/json'

                  },


                  body:
                    JSON.stringify({

                      items: [

                        {

                          id: id,

                          quantity: 1

                        }

                      ]

                    })

                }
              );


            if (!response.ok) {


              var body =
                await response
                  .json()
                  .catch(
                    function () {

                      return {};

                    }
                  );


              throw new Error(
                body.description ||
                'カートへの追加に失敗しました。'
              );

            }


            add.textContent =
              'カートに追加しました ✓';


            if (status) {

              status.textContent =
                'カートに追加しました。';

            }


            document.dispatchEvent(
              new CustomEvent(
                'cart:refresh'
              )
            );


            document.dispatchEvent(
              new CustomEvent(
                'cart:updated'
              )
            );


            setTimeout(
              function () {


                add.textContent =
                  originalLabel;


                var current =
                  findVariant();


                add.disabled =
                  !current ||
                  !current.available;

              },
              2500
            );


          } catch (error) {


            if (status) {

              status.textContent =
                error.message ||
                'カートへの追加に失敗しました。';

            }


            add.textContent =
              originalLabel;


            var current =
              findVariant();


            add.disabled =
              !current ||
              !current.available;

          }

        }
      );

    }


    /* =========================
       INITIAL STATE
    ========================= */

    /*
      上の選択エリアは
      初期状態では未選択
    */

    selected = '';


    setButtonState(
      null
    );


    /*
      下の通常商品フォームは
      Shopify側の初期Variantを維持
    */

    if (finalSelect) {


      var initialVariant =
        findVariantById(
          finalSelect.value
        );


      if (initialVariant) {


        var initialButton =
          findButtonForVariant(
            initialVariant
          );


        if (finalPrice) {

          finalPrice.textContent =
            money(
              initialVariant.price
            );

        }


        if (finalAdd) {

          finalAdd.disabled =
            !initialVariant.available;

        }


        var initialImage =
          getImage(
            initialButton,
            initialVariant
          );


        if (
          initialImage &&
          finalImage
        ) {

          setImage(
            finalImage,
            initialImage,
            getImageAlt(
              initialButton
            )
          );

        }

      }

    }


    /*
      初期SOLD OUT表示
    */

    refreshStock();


    /*
      上の購入エリアだけ更新
    */

    if (resultText) {

      resultText.textContent =
        '香りを選択してください';

    }


    if (status) {

      status.textContent =
        '香りをお選びください。';

    }


    if (add) {

      add.dataset.variantId = '';

      add.disabled = true;

    }

  });

})();